import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Row, Col, Image, Modal, Typography } from "antd";
import { get } from "lodash";
import Flags from "./Flags/Flags";
import Button from "../functional_components/Button/PFButton";
import { ENVIRONMENT } from "../../utils/properties";
import { useNavigate } from "react-router-dom";
import { UserOutlined, LogoutOutlined, QuestionCircleOutlined } from "@ant-design/icons";

const { confirm } = Modal;
const { Link } = Typography;

import pfIcon from "../../assets/images/pininfarina-logo-icon.png";
import pfLogo from "../../assets/images/pininfarina-logo-text.png";
import { userLogout } from "../../redux/ducks/UserInfo";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  const userMaster = useSelector((state) => get(state.userInfoDuck, "userMaster", {}));

  const userRoles = () => {
    let userRolesString = "";
    userInfo.roles.map((role, i) => {
      const roleTranslation = t(`roles.${role}`);
      const separator = userInfo.roles.length > 1 && i + 1 < userInfo.roles.length ? " | " : "";
      userRolesString += `${roleTranslation}${separator}`;
    });
    return userRolesString;
  };

  const doLogout = () => () => {
    confirm({
      title: t(`general.youWantLogout`),
      icon: <QuestionCircleOutlined />,
      content: "",
      onOk() {
        localStorage.clear();
        dispatch(userLogout());
        navigate("/login");
      },
      onCancel() {},
      cancelText: t("general.cancel"),
    });
  };
  return (
    <Row justify="center" align="middle">
      <Col xs={24} sm={24} md={6} className="d-flex">
        <Link href={ENVIRONMENT.BASE_URL}>
          <Image preview={false} src={pfIcon} width={80} />
        </Link>
      </Col>
      <Col className="center" xs={0} sm={24} md={12}>
        <Image preview={false} src={pfLogo} />
      </Col>
      <Col xs={24} sm={24} md={6}>
        <Row type="flex" align="middle" justify="end">
          <Col className="right">{userInfo.roles && <strong>{userRoles()}</strong>}</Col>
          <Col>
            <Flags />
          </Col>
        </Row>
        {userInfo.name && (
          <Row className="right">
            <Col span={24} className="user-right">
              <span>
                {get(userMaster, "token", "") !== "" ? (
                  <Link href="/choose-user">
                    <UserOutlined className="PFred" />
                  </Link>
                ) : (
                  <UserOutlined className="PFred" />
                )}
              </span>
              <span>
                <strong>{userInfo.name}</strong>
              </span>
              <span>
                <Button
                  currentIcon={<LogoutOutlined className="icon-small" />}
                  clickCallback={doLogout()}
                  currentSize="small"
                  floatRight
                />
              </span>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default Header;
